import React from 'react';

import Item from './Item';

const TextItem = ({text, ...props}) => (
    <Item
        {...props}
        name={text}
        onSelect={null}
        isAirport={false}
        isAvailable={true /* to avoid the item having a shop icon */ }
    />
);

export default TextItem;
